module.exports = __webpack_public_path__ + "img/144.b773f61c.png";